import { ReducerFunctions } from "../../config/helper";
import { UploadProdImg } from "../admin/Action";
import {
  CustomerActivate,
  ForgotPassoword,
  NewPassoword,
  Register,
  ResetPassoword,
  Sessions,
  Logout,
} from "./Action";

export const register_reducer = ReducerFunctions(Register, {});
export const sessions_reducer = ReducerFunctions(Sessions, {});
export const logout_reducer = ReducerFunctions(Logout, {});
export const new_password_reducer = ReducerFunctions(NewPassoword, {});
export const forgot_password_reducer = ReducerFunctions(ForgotPassoword, {});
export const reset_password_reducer = ReducerFunctions(ResetPassoword, {});
export const customer_activate_reducer = ReducerFunctions(CustomerActivate, {});
export const upload_img_reducer = ReducerFunctions(UploadProdImg, {});
